class SearchIcon {
	constructor(blockEl) {
		this.el = blockEl;
		this.loadSearchIcon();
	}

	loadSearchIcon = () => {
		const button = this.el.querySelector('button');
		button.innerHTML = '<span class="tmpl-archive__search-icon"></span>';
	};
}

export default SearchIcon;
